$(document).ready(function(){
  AOS.init();



  $(function() {
    $('.currency-selector').on('change', function() {
      $.ajax({
        type: 'POST',
        url: '/cart/update',
        data: $('#currency-form').serialize(),
        success: function(data) {
          alert('Currency updated!');
        },
        error: function(XMLHttpRequest, textStatus) {
          alert('Currency update failed.');
        }
      });
    });
  });

  const swiper = new Swiper('.swiper', {
      direction: 'horizontal',
      slideShadows: true,
      spaceBetween: 60,
      slidesPerView: 3,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 0          
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 0
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 60
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 60
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 60
        },
    
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

  });

  $(".close").click(function(){
    $(".modal").removeClass("show");
    $(".modal").css("display", "none");
    $(".modal-backdrop").remove();
    $("body").removeClass("modal-open");
    $("body").css("overflow", "auto");
  });

  jQuery(".pro-dec-social").insertAfter(".description-review-wrapper");  
  jQuery(".custom-payment-options").insertAfter(".description-review-wrapper");
  
  
/*    $("body").niceScroll({
      cursorcolor: "#f67f28",
      cursorborder: "1px solid #fff",
      cursorborderradius: "5px",
      cursorwidth: "8px",
      scrollspeed: 100,
      mousescrollstep: 100,
      smoothscroll: true,
      enablemousewheel: true,
    });
*/
  
});